import React, { useEffect } from "react";
import "./App.css";
import Header from "./Components/Header/Header";
import Home from "./Components/Home/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Checkout from "./Components/Checkout/Checkout";
import Login from "./Components/Login Page/Login";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Payment from "./Components/Payment Page/Payment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from "./Components/Orders Page/Orders";

const promise = loadStripe(
  // "pk_test_51MBbvHSD0suCjABabpQwIolGgIwaP6ZSCj0gNFuv3Eb1723oMV7X8A1XqBBP1OPkNxkywBBMnI6ftAShrEwJE2cP001lLSrzk3"
 //"pk_test_51MBbvHSD0suCjABabpQwIolGgIwaP6ZSCj0gNFuv3Eb1723oMV7X8A1XqBBP1OPkNxkywBBMnI6ftAShrEwJE2cP001lLSrzk3"
 "pk_test_51LFgpvF3oeaFZvcR42YhjIj4cbs5OrXHildtgt6vAuvph0QPhBahVFZrPXjkDgfOJqZuDde0jODHHCGowk0ZFmif00SNh4J0Tz"
);

function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    // will only run once when the app component loads...

    auth.onAuthStateChanged((authUser) => {
      console.log("THE USER IS >>>", authUser);

      if (authUser) {
        //the user just logged in / the user was logged in

        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/orders" element={[<Header />, <Orders />]} />
          <Route path="/login" element={<Login />} />
          <Route path="/checkout" element={[<Header />, <Checkout />]} />
          <Route
            path="/payment"
            element={[
              <Header />,
              <Elements stripe={promise}>
                <Payment />
              </Elements>,
            ]}
          />
          <Route path="/" element={[<Header />, <Home />]} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
